import merge from "lodash/merge";
import { LoggerName, getLogger } from "~/modules/logger";
import { ErrorCode, ErrorSeverity, FlexSdkError } from "~/modules/error";
import { sendTrackingEvent } from "../../ActionUtils";
import { Action } from "~/modules/actions/Action";
import { EVENTS } from "~/modules/analytics/Analytics";
import { TaskRouterImpl } from "~/packages/taskrouter/TaskRouterImpl";
import { AnalyticsImpl } from "~/modules/analytics/AnalyticsImpl";
import { ContextInstance, ContextManager } from "~/modules/contextManager/ContextManager";




export interface SetWorkerAttributesOptions {
    mergeExisting?: boolean;
}





















export class SetWorkerAttributes implements Action<Promise<void>> {
    


    #targetWorkerSid: string;

    


    #attributes: Record<string, any>;

    


    #options?: SetWorkerAttributesOptions;

    constructor(targetWorkerSid: string, attributes: Record<string, any>, options?: SetWorkerAttributesOptions) {
        this.#targetWorkerSid = targetWorkerSid;
        this.#attributes = attributes;
        this.#options = options;
    }

    async run(ctx: {}) {
        const context = ctx as ContextManager;
        const taskRouter = context.retrieveInstanceOf(ContextInstance.TaskRouter, TaskRouterImpl);
        await taskRouter.init();
        const logger = getLogger(context)(LoggerName.Client);
        const analytics = context.retrieveInstanceOf(ContextInstance.AnalyticsImpl, AnalyticsImpl);

        const worker = taskRouter.worker;
        const mergeExisting = this.#options?.mergeExisting || false;

        logger.debug(`setWorkerAttributes invoked with targetWorkerSid: ${this.#targetWorkerSid}`);

        if (!worker) {
            const errorMsg = "setWorkerAttributes: worker is not initialized";
            logger.error(errorMsg);
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }

        const newAttributes = mergeExisting ? merge(taskRouter.worker.attributes, this.#attributes) : this.#attributes;

        try {
            await taskRouter.worker.setWorkerAttributes(this.#targetWorkerSid, newAttributes);

            sendTrackingEvent(EVENTS.SetWorkerAttributesCompleted, analytics, worker, {
                targetWorkerSid: this.#targetWorkerSid,
                mergeExisting
            });

            return Promise.resolve();
        } catch (error) {
            const errorMsg = `setWorkerAttributes: Could not set worker attributes: ${error.message}`;
            sendTrackingEvent(EVENTS.SetWorkerAttributesCompleted, analytics, worker, {
                error: errorMsg,
                targetWorkerSid: this.#targetWorkerSid,
                mergeExisting
            });
            throw new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg);
        }
    }
}
